import { render, staticRenderFns } from "./CuentasPublicas.vue?vue&type=template&id=bcfff0f0"
import script from "./CuentasPublicas.vue?vue&type=script&lang=js"
export * from "./CuentasPublicas.vue?vue&type=script&lang=js"
import style0 from "./CuentasPublicas.vue?vue&type=style&index=0&id=bcfff0f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports